export enum ContabilDashboardRouter {
  Index = "contabil_dashboard_index",
  Tributos = "contabil_dashboard_tributos",
  Contratar = "contabil_auto-contratação"
}
